



















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import DateUtils from '@/common/js/DateUtils'
import moment from 'moment'

class PageFlowRequest extends PageRequest {
    beginTime?: Date;
    endTime?: Date;
    userCode: string;
    orderNumber: string;
    channel?: number;
    isRelated?: boolean;
    constructor() {
        super();
        this.isRelated = null;
        this.channel = null;
    }
}

@Component({
    name: "flow",
    components: {  }
})
export default class flows extends AbpBase {
    channel = Enums.getEnum(Enums.UserAmountChannel, true);
    pagerequest: PageFlowRequest = new PageFlowRequest();
    createTime: Date[] = [moment(moment(new Date()).add(-10, 'days'), "YYYYMMDD").toDate(), new Date()];
    addLoding = false;
    get list() {
        return this.$store.state.backflows.list;
    };
    get loading() {
        return this.$store.state.backflows.loading;
    };
    pageChange(page: number) {
        this.$store.commit('backflows/setCurrentPage', page);
        this.getpage();
    };
    pagesizeChange(pagesize: number) {
        this.$store.commit('backflows/setPageSize', pagesize);
        this.getpage();
    };

    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.createTime.length > 0) {
            this.pagerequest.beginTime = this.createTime[0];
        }
        if (this.createTime.length > 1) {
            this.pagerequest.endTime = this.createTime[1];
        }

        await this.$store.dispatch({
            type: 'backflows/getAll',
            data: this.pagerequest
        })
    }
    async searchPage() {
        this.$store.state.backflows.currentPage=1;
        this.getpage();
    }
    get pageSize() {
        return this.$store.state.backflows.pageSize;
    }
    get totalCount() {
        return this.$store.state.backflows.totalCount;
    }
    get currentPage() {
        return this.$store.state.backflows.currentPage;
    }
    columns = [{
        title: '渠道',
        key: 'channel',
        render: (h: any, params: any) => {
            return h('span', Enums.UserAmountChannel.filter(function (item) { return item.value == params.row.channel })[0].name);
        },
        width: 150,
        fixed: 'left',
    }, {
        title: '仓库名称',
        key: 'warehouseName',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', params.row.warehouseName ? params.row.warehouseName : params.row.storeName);
            }
        }, {
            title: '用户编码',
            key: 'userCode',
            width: 150,
        },{
        title: '订单编号',
            key: 'orderNumber',
        width: 250,

        },
        {
            title: '备注',
            key: 'reMark',
            width: 200,

        },
        {
            title: '创建时间',
            key: 'createTime',
            width: 150,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
            }
    }, {
            title: '积分',
            key: 'incurredAmount',
            width: 275,
        }, {
            title: '剩余积分',
            key: 'balance',
            width: 275,
        },
    ]
    async created() {
        this.getpage();
    }

    async exportexpress() {
      //  this.addLoding = true;
        await this.$store.dispatch({
            type: 'backflows/impotExcel',
            data: this.pagerequest
        }).finally(() => {
      //      this.addLoding = false;
        });
    }
}
